import React from "react"
import { useNavigate } from "react-router"
import { Button, Typography } from "antd"
import { LeftOutlined } from "@ant-design/icons"
import classNames from "classnames"

import css from "./index.module.css"

type Props = {
  backAction?: () => void
  button?: React.ReactNode
  className?: string
  hideBack?: boolean
  title: string
  url?: string
}
const { Title } = Typography

export const Navigation = ({
  backAction,
  button,
  className = "",
  hideBack = false,
  title,
  url,
}: Props) => {
  const navigate = useNavigate()

  const getPath = () => {
    if (url) {
      return navigate(url)
    }

    return navigate(-1)
  }

  return (
    <div className={classNames([css.navigation, className])}>
      <div className={css.wrapper}>
        {!hideBack && (
          <Button
            className={css.backButton}
            icon={<LeftOutlined />}
            id="GENERATED_ID_NAVIGATION_BUTTON_BACK_1"
            onClick={() => (backAction ? backAction() : getPath())}
          >
            Back
          </Button>
        )}

        <Title
          className={css.title}
          level={4}
          style={{ marginBottom: 0, marginTop: 0 }}
        >
          {title}
        </Title>
        {button && <div className={css.action}>{button}</div>}
      </div>
    </div>
  )
}
